
import { defineComponent } from "vue";import TalentList from "./MeviusStoryTalentList.vue";
import Usecase from "@/components/common_presentational/Usecase.vue";

export default defineComponent({
  name: "MeviusStoryScreen",
  components: {
    TalentList,
    Usecase
  },
});
